import { useLayoutEffect, useRef } from "react";
import { bool, node } from "prop-types";
import { EDITOR_CONTAINER_ID } from "@utils";
import { useStores } from "@hooks";
import {
  useEstimateEditorStore,
  useEstimateStructure,
  useEstimateEditorSettings,
  handleFixedTableHeader,
  UserMoveBoard, ProposalAppBar
} from "@tools";
import { Grid } from "@material-ui/core";
import useStyle from "./styles/EditorContainer.style";
import classnames from "classnames";

export const EditorContainer = ({
  showUserMovement,
  showPresetToolbar,
  isLibrary,
  children,
}) => {

  const structure = useEstimateStructure();
  const editorStore = useEstimateEditorStore();
  const { stateStore } = useStores();
  const { sectionsReordered } = useEstimateEditorSettings();
  const classes = useStyle();

  const scrollbarRef = useRef(null);
  
  useLayoutEffect(() => {
    scrollbarRef.current?.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }, [editorStore.proposalStep])
  
  useLayoutEffect(() => {
    stateStore.setScrollHandler(handleScroll);
    return () => {
      stateStore.resetScrollHandler();
    };
  }, []);
  
  const handleScroll = (e) => {
    if (!sectionsReordered)
      updatePinnedHeaders();
    editorStore.setVersionScroll(e.target.scrollTop);
  };

  const updatePinnedHeaders = () => {
    structure.sections.forEach((m, i) => {
      const tableHeader = document.getElementById("tableHeader" + i);
      const tableContainer = document.getElementById("breakdownContainer" + i);

      if (tableHeader)
        handleFixedTableHeader(
          tableHeader,
          tableContainer,
          isLibrary ? -38 - 16 : -16,
        );
    });
  };

  return (
    <Grid
      item container
      id={EDITOR_CONTAINER_ID}
      ref={scrollbarRef}
      className={classnames("h-max", classes.root)}
    >
      { showUserMovement && <UserMoveBoard containerRef={scrollbarRef.current} /> }
      { showPresetToolbar && <ProposalAppBar/> }
      { Boolean(scrollbarRef) && children }
    </Grid>
  )
}

EditorContainer.propTypes = {
  showUserMovement: bool,
  showPresetToolbar: bool,
  isLibrary: bool,
  children: node
}